module.exports = __webpack_public_path__ + "static/media/icon_19.8900ceb3.svg";